import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Params, Router } from '@angular/router';
import { slideInUpOnEnterAnimation } from '@app/animation/slideDownToUp';
import { CacheObjectService, DeviceService, EventTrackerService } from '@app/core';
import { AppParametersService } from '@app/core/token/app-parameters.service';
import { ScrollToLastPosition } from '@app/helper/scroll-to-last-position';
import { ProductTypeEnum } from '@app/interfaces/iBook';
import { IndicatorService } from '@app/shared';
import { environment } from '@env/environment';
import { filter } from 'rxjs/operators';
import { CLPService } from '../../clp.service';


@Component({
  selector: "navaar-plp-list",
  templateUrl: "./plp-list.component.html",
  styleUrls: ["./plp-list.component.scss"],
  animations: [
    trigger("overlayAnimation", [
      state(
        "void",
        style({
          opacity: 0,
        })
      ),
      state(
        "visible",
        style({
          opacity: 1,
        })
      ),
      transition("* => *", animate("300ms cubic-bezier(0.25, 0.8, 0.25, 1)")),
    ]),
    slideInUpOnEnterAnimation({ anchor: "slidePopup" }),
  ],
})
export class PlpListComponent extends ScrollToLastPosition implements OnInit {
  SWIPE_ACTION = { DOWN: "swipedown" };
  public sortList = {
    title: "مرتب سازی",
    items: [
      {
        title: " حروف الفبا",
        type: "Title",
      },
      {
        title: "محبوب ترین ها",
        type: "RatingAverage desc",
      },
      {
        title: "قدیمی ترین",
        type: "WebPublicationDate",
      },
      {
        title: "جدیدترین",
        type: "WebPublicationDate desc",
      },
    ],
  };

  public title: string;
  public identifier: number;
  public books: Array<any> = [];
  public isLoading: boolean = false;
  public isEnd: boolean = false;
  public sort: boolean = false;
  public items: Array<any> = [];
  public get pageNo(): number {
    return this.cache.pageNumer;
  }
  public set pageNo(v: number) {
    this.cache.pageNumer = v;
  }
  public contentType: ProductTypeEnum;
  public productType: typeof ProductTypeEnum = ProductTypeEnum;
  public readonly BASE_HREF_IMAGE = environment.imageUrl;

  public AnimationSortListScrollbar: string;
  container: HTMLDivElement;
  visible: boolean = false;
  public currentPage: number = 0;
  public skip: number = 0;
  public readonly PAGE_SIZE = 20;
  public pages: number = 0;
  public total: number = 0;
  public orderby: string;
  public sortItems: boolean = false;
  public genresInfo = null;
  public isActive = [];
  public moreTextDesc: boolean = false;

  constructor(
    private readonly parametersService: AppParametersService,
    public readonly eventTracker: EventTrackerService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly indicator: IndicatorService,
    private readonly chkd: ChangeDetectorRef,
    public readonly device: DeviceService,
    private readonly clpService: CLPService,
    private readonly cache: CacheObjectService<any>
  ) {
    super(router);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.restoredState) this.clpService.isBackFromItem = true;
      });
  }

  public async ngOnInit() {
    this.activatedRoute.paramMap.subscribe(x => {
      this.title = this.activatedRoute.snapshot.queryParamMap.get("title");
      this.identifier = +this.activatedRoute.snapshot.paramMap.get("id");
      const isSeries = this.activatedRoute.snapshot.paramMap.get("isSeries");
      const contentType = this.activatedRoute.snapshot.queryParamMap.get("contentType");
      if (contentType)
        this.contentType = ProductTypeEnum[contentType];
      else if (isSeries === 'true') {
        this.router.navigate(
          ['clp','listItem', this.identifier],
          {
            queryParams: { contentType : 'Podcast' },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          });

        this.contentType = ProductTypeEnum.Podcast;
      }
    });
    for (let i = 0, len = this.sortList.items.length; i < len; i++) {
      this.isActive[i] = false;
    }
    if (this.contentType) {
      if (this.contentType === ProductTypeEnum.AudioSeries || this.contentType === ProductTypeEnum.Podcast) {
        this.getGenreInfo()
      }
    }
    this.getGenreById(this.orderby, this.skip);
  }
  public setActive(ind) {
    for (let i = 0, len = this.isActive.length; i < len; i++) {
      this.isActive[i] = i === ind;
    }
  }
  public goToPage(page: number) {
    this.paginate();
  }

  public paginate() {
    if (this.skip === 0) {
      this.pageNo = 1;
    } else {
      this.pageNo += 1;
    }

    this.skip = this.pageNo * this.PAGE_SIZE;
    this.clpService.isBackFromItem = false;
    this.getGenreById(this.orderby, this.skip);
  }
  async getGenreInfo() {
    let Url = `/api/genres/${this.identifier}/info`;
    await this.cache.getObjectCache(Url).subscribe((c) => {
      this.genresInfo = c;
      if (!this.title)
        this.title = c.name;
    });
  }
  async getGenreById(Orderby, skip) {
    this.isLoading = true;
    const clientId = this.parametersService.clientId;
    let Url = `/api/audiobooks/genre/${this.identifier}?clientId=${clientId}&$inlinecount=allpages`;
    if (skip != undefined) {
      Url += `&$skip=${skip}`;
    }
    if (this.PAGE_SIZE != undefined) {
      Url += `&$top=${this.PAGE_SIZE}`;
    }
    if (Orderby != undefined && Orderby != "") {
      Url += `&$orderby=${Orderby}`;
    }

    await this.cache.getObjectCache(Url).subscribe((c) => {
      let allItem = [];
      allItem = c.items;

      if (this.skip === 0) {
        this.items = [];
        this.items = allItem;
      }
      if (this.skip > 0) {
        this.items = [...this.items, ...allItem];
      }

      this.isLoading = false;
      this.isEnd = this.items.length === c.count;
      this.total = c.count;
      this.pages = Math.ceil(this.total / this.PAGE_SIZE);
      this.indicator.hide();
      this.indicator.hideHude();
      this.chkd.detectChanges();
    });
    if (this.clpService.isBackFromItem) {
      super.scrollToPosition();
    }
  }
  sortGenre(Orderby) {
    setTimeout(() => {
      this.visible = false;
      this.AnimationSortListScrollbar = "void";
      this.orderby = Orderby;
      this.sortItems = true;
      this.items = [];
      this.skip = 0;
      this.getGenreById(Orderby, this.skip);
    }, 100);
  }

  onOVerlayAnimationStart(event: AnimationEvent) {
    if (event.toState === "visible") {
      this.container = event.element;
    }
  }
  swipe(action: string) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.close();
    }
  }
  public close() {
    this.visible = false;
    this.AnimationSortListScrollbar = "void";
  }
  public onSortlistScrollbar(event: AnimationEvent) {
    if (event.toState === "void") {
      this.AnimationSortListScrollbar = "";
    }
  }

  public showSortList() {
    this.visible = true;
  }
  public moreText() {
    this.moreTextDesc = !this.moreTextDesc;
  }
}
